module.exports = __webpack_public_path__ + "static/img/img4.cb2ed33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img4.png
// module id = LIFA
// module chunks = 1